<script setup>
import { ref, getCurrentInstance } from 'vue'
import { DriverStore } from '../pinia/Driver.js'
import PayPal from './PayPal.vue'
import benefits from '../configs/premium.json'

const Driver = DriverStore()
const { proxy } = getCurrentInstance()

async function capture(data) {
    const res = await proxy.$api({
        serviceName: "paypalCheckout",
        methodName: "verify",
        parameters: [data.orderID]
    })
    if (res == "ok") {
        Driver.user.premium = "1"
    }
}
</script>

<template>
<div v-if="Driver.user.premium == '0'">

    <div v-if="Driver.user.discord == null" class="discord-required">
        <v-icon size="x-large" color="amber" class="warning-icon">mdi-discord</v-icon>
        <h3>Discord Required</h3>
        <p>To subscribe to Premium, you must have a Discord account linked to your NightRiderz account.</p>
    </div>

    <div v-if="Driver.user.discord != null" class="purchase-container">
        <div class="premium-info">
            <div class="info-card">
                <div class="card-content">
                    <v-icon size="x-large" color="amber" class="card-icon">mdi-shield-star</v-icon>
                    <h3>Premium Membership</h3>
                    <ul class="feature-list">
                        <li>
                            <v-icon size="small" color="amber">mdi-check-circle</v-icon>
                            Lifetime access to all premium features
                        </li>
                        <li>
                            <v-icon size="small" color="amber">mdi-check-circle</v-icon>
                            Instant activation on your current driver
                        </li>
                        <li>
                            <v-icon size="small" color="amber">mdi-check-circle</v-icon>
                            Access to future premium features
                        </li>
                        <li>
                            <v-icon size="small" color="amber">mdi-check-circle</v-icon>
                            Support server development
                        </li>
                    </ul>
                    <div class="price-tag">
                        <span class="amount">€5.99</span>
                        <span class="period">one-time payment</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="payment-section">
            <PayPal @capture="capture" />
        </div>
    </div>


</div>

<div v-else="Driver.user.premium">
    <div class="premium-active">
        <h2>Thank you for your Premium support!</h2>
        <p class="support-message">Your contribution helps us maintain and improve our dedicated servers and infrastructure.</p>
        
        <div class="benefits-grid">
            <div v-for="benefit in benefits" :key="benefit.title" class="benefit-card">
                <div class="benefit-icon">
                    <v-icon size="x-large" :icon="'mdi-' + benefit.icone"></v-icon>
                </div>
                <h3>{{ benefit.title }}</h3>
                <p v-html="benefit.text"></p>
            </div>
        </div>
    </div>
</div>
</template>

<style scoped>
.premium-benefits {
    margin: 24px 0;
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    padding: 16px;
}

.premium-active {
    text-align: center;
    padding: 2rem;
    max-height: 80vh;
    overflow-y: auto;
    /* Styliser la barre de défilement */
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 215, 0, 0.5) rgba(255, 255, 255, 0.1);
}

/* Style de la barre de défilement pour Webkit (Chrome, Safari, etc.) */
.premium-active::-webkit-scrollbar {
    width: 8px;
}

.premium-active::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
}

.premium-active::-webkit-scrollbar-thumb {
    background-color: rgba(255, 215, 0, 0.5);
    border-radius: 4px;
}

.premium-active::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 215, 0, 0.7);
}

.premium-active h2 {
    color: #ffd700;
    font-size: 2rem;
    margin-bottom: 1rem;
}

.support-message {
    color: #ccc;
    font-size: 1.1rem;
    margin-bottom: 2rem;
}

.benefits-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.5rem;
    margin-top: 2rem;
}

.benefit-card {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    padding: 1.5rem;
    transition: transform 0.2s, box-shadow 0.2s;
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.benefit-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.benefit-icon {
    font-size: 2.5rem;
    margin-bottom: 1rem;
}

.benefit-card h3 {
    color: #ffd700;
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
}

.benefit-card p {
    color: #ccc;
    font-size: 0.9rem;
    line-height: 1.4;
}

.discord-required {
    text-align: center;
    padding: 2rem;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    border: 1px solid rgba(255, 215, 0, 0.2);
    margin: 1rem;
}

.discord-required h3 {
    color: #ffd700;
    margin: 1rem 0;
    font-size: 1.4rem;
}

.discord-required p {
    color: #ccc;
    font-size: 1rem;
    line-height: 1.5;
}

.warning-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
}

.purchase-container {
    padding: 1rem;
    max-height: 80vh;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 215, 0, 0.5) rgba(255, 255, 255, 0.1);
}

.purchase-container::-webkit-scrollbar {
    width: 8px;
}

.purchase-container::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
}

.purchase-container::-webkit-scrollbar-thumb {
    background-color: rgba(255, 215, 0, 0.5);
    border-radius: 4px;
}

.purchase-container::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 215, 0, 0.7);
}

.premium-info {
    margin-bottom: 2rem;
}

.info-card {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    border: 1px solid rgba(255, 215, 0, 0.2);
    transition: transform 0.2s, box-shadow 0.2s;
    overflow: hidden;
}

.info-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.card-content {
    padding: 2rem;
    text-align: center;
}

.card-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
}

.info-card h3 {
    color: #ffd700;
    font-size: 1.6rem;
    margin-bottom: 1.5rem;
}

.feature-list {
    list-style: none;
    padding: 0;
    margin: 1.5rem 0;
    text-align: left;
}

.feature-list li {
    color: #ccc;
    margin: 0.8rem 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.price-tag {
    margin-top: 2rem;
    padding: 1rem;
    background: rgba(255, 215, 0, 0.1);
    border-radius: 8px;
    display: inline-block;
}

.price-tag .amount {
    font-size: 2.5rem;
    font-weight: bold;
    color: #ffd700;
    display: block;
}

.price-tag .period {
    color: #ccc;
    font-size: 0.9rem;
}

.payment-section {
    justify-content: center;
    padding: 1.5rem;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid rgba(255, 215, 0, 0.3);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
}

/* Style pour le bouton PayPal (à adapter selon le composant PayPal) */
:deep(.paypal-button) {
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
}
</style>
